import de from "./de.json";
import en from "./en.json";
import fr from "./fr.json";
import hu from "./hu.json";
import br from "./br.json";
let mr = {};
let hn = {};
export const translationStore = { de, en, fr, hu, br, mr, hn };

export const languageOptions = {
  de: "de",
  en: "en",
  fr: "fr",
  hu: "hu",
  br: "br",
  mr: "mr",
  hn: "hn",
};
